
import React from "react";
import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { useSubscriptionService } from "@/services/subscriptionService";
import { format } from "date-fns";

export const SubscriptionBadge: React.FC = () => {
  const { userSubscription, isLoading } = useSubscriptionService();

  if (isLoading) {
    return <Badge variant="outline" className="animate-pulse">Loading...</Badge>;
  }

  if (!userSubscription) {
    return <Badge variant="destructive">No Subscription</Badge>;
  }

  // Define badge variant based on subscription plan
  const getBadgeVariant = () => {
    switch (userSubscription.subscription_plan) {
      case "FREE":
        return "outline";
      case "ESSENTIAL":
        return "secondary";
      case "GROWTH":
        return "default";
      case "PRO":
        return "default";
      default:
        return "outline";
    }
  };

  // Format expiry date
  const expiryDate = userSubscription.expiry_date 
    ? format(new Date(userSubscription.expiry_date), "MMM d, yyyy")
    : "Unknown";

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge variant={getBadgeVariant()} className="cursor-help">
            {userSubscription.subscription_plan === "FREE" 
              ? "Free Trial" 
              : userSubscription.subscription_plan}
          </Badge>
        </TooltipTrigger>
        <TooltipContent>
          <div className="text-sm">
            <p className="font-medium">{userSubscription.subscription_plan === "FREE" ? "Free Trial" : userSubscription.subscription_plan} Plan</p>
            <p>Videos: {userSubscription.videos_per_day}/day</p>
            <p>Messages: {userSubscription.messages_per_video}/video</p>
            <p>Max Duration: {userSubscription.max_video_duration} min</p>
            <p>Expires: {expiryDate}</p>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
